import type { UseRouterReturn } from '@application/utils';

export const adoptionsLinks = (
  translate: UseRouterReturn['translate'],
  navigateToRoute: UseRouterReturn['navigateToRoute'],
  routeLocationDescriptor: UseRouterReturn['routeLocationDescriptor'],
  isLoggedIn: boolean,
  shouldShowArticles = false,
) => {
  return [
    {
      label: translate('header.puppies'),
      onClick: () => navigateToRoute('litterList'),
      link: routeLocationDescriptor('litterList'),
      links: [
        {
          label: translate('header.puppiesListing'),
          onClick: () => navigateToRoute('litterList'),
          link: routeLocationDescriptor('litterList'),
        },
        {
          label: translate('header.breedsListing'),
          onClick: () => navigateToRoute('breedList'),
          link: routeLocationDescriptor('breedList'),
        },
        {
          label: translate('header.breedComparator'),
          onClick: () => navigateToRoute('breedComparator'),
          link: routeLocationDescriptor('breedComparator'),
        },

        ...(!isLoggedIn
          ? [
              {
                label: translate('header.breedersRegister'),
                onClick: () => navigateToRoute('breederLanding'),
                link: routeLocationDescriptor('breederLanding'),
              },
            ]
          : []),
      ],
    },
    {
      label: translate('header.breeders'),
      onClick: () => navigateToRoute('breederList'),
      link: routeLocationDescriptor('breederList'),
      links: [
        {
          label: translate('header.breedersListing'),
          onClick: () => navigateToRoute('breederList'),
          link: routeLocationDescriptor('breederList'),
        },
        {
          label: translate('header.studsListing'),
          onClick: () => navigateToRoute('studList'),
          link: routeLocationDescriptor('studList'),
        },
        {
          label: translate('header.breedsListing'),
          onClick: () => navigateToRoute('breedList'),
          link: routeLocationDescriptor('breedList'),
        },
        {
          label: translate('header.breedComparator'),
          onClick: () => navigateToRoute('breedComparator'),
          link: routeLocationDescriptor('breedComparator'),
        },
        ...(!isLoggedIn
          ? [
              {
                label: translate('header.breedersRegister'),
                onClick: () => navigateToRoute('breederLanding'),
                link: routeLocationDescriptor('breederLanding'),
              },
            ]
          : []),
      ],
    },
    {
      label: translate('header.shelters'),
      onClick: () => navigateToRoute('shelterList'),
      link: routeLocationDescriptor('shelterList'),
      links: [
        {
          label: translate('header.sheltersListing'),
          onClick: () => navigateToRoute('shelterList'),
          link: routeLocationDescriptor('shelterList'),
        },
        {
          label: translate('header.breedsListing'),
          onClick: () => navigateToRoute('breedList'),
          link: routeLocationDescriptor('breedList'),
        },
        {
          label: translate('header.breedComparator'),
          onClick: () => navigateToRoute('breedComparator'),
          link: routeLocationDescriptor('breedComparator'),
        },
        ...(!isLoggedIn
          ? [
              {
                label: translate('header.sheltersRegister'),
                onClick: () => navigateToRoute('joinShelter'),
                link: routeLocationDescriptor('joinShelter'),
              },
            ]
          : []),
      ],
    },
    {
      label: translate('header.pros'),
      onClick: () => navigateToRoute('proLanding'),
      link: routeLocationDescriptor('proLanding'),
      links: [
        {
          label: translate('header.vets'),
          onClick: () => navigateToRoute('vetList'),
          link: routeLocationDescriptor('vetList'),
        },
        {
          label: translate('header.groomers'),
          onClick: () => navigateToRoute('groomerList'),
          link: routeLocationDescriptor('groomerList'),
        },
        {
          label: translate('header.educators'),
          onClick: () => navigateToRoute('educatorList'),
          link: routeLocationDescriptor('educatorList'),
        },
        ...(!isLoggedIn
          ? [
              {
                label: translate('header.prosRegister'),
                onClick: () => navigateToRoute('joinLanding'),
                link: routeLocationDescriptor('joinLanding'),
              },
            ]
          : []),
      ],
    },
    ...(shouldShowArticles
      ? [
          {
            label: translate('header.articles'),
            onClick: () => navigateToRoute('articleList'),
            link: routeLocationDescriptor('articleList'),
          },
        ]
      : []),
  ];
};
